import { Row, Col } from 'react-bootstrap';
import FooterComponent from '../shared/footer.component';
import HeaderComponent from './component/header.component';
import InstructionComponent from './component/instruction.component';
import OverviewComponent from './component/overview.component';
import SectionPickerComponent from './component/section-picker.component';
import SettingComponent from './component/setting.component';
import TimerComponent from './component/timer.component';
import FullScreenComponent from './component/full-screen.component';
import JeeQuestionHolderComponent from './component/jee/jee-question-holder.component';

const TestJeeDPage = () => {
  return (
    <>
      <section className="mx-xl-5 mx-lg-4 mx-3 px-1 pt-4 d-flex flex-column q--section--wrapper">
        <Row className="m-0 mb-1">
          <Col lg={12} className="px-0 text-white d-flex align-items-center">
            <HeaderComponent />
            <div className="ms-auto d-flex align-items-center">
              <TimerComponent />

              <FullScreenComponent />

              <SettingComponent />

              <OverviewComponent />
            </div>
          </Col>
        </Row>

        <div className="bg-secondary rounded-2 flex-grow-1 py-2 px-4 mb-2">
          <Row>
            <Col lg={4}>
              <div className="d-flex align-items-center">
                <SectionPickerComponent />
                <InstructionComponent />
              </div>
            </Col>
          </Row>

          <JeeQuestionHolderComponent />
        </div>

        <FooterComponent />
      </section>
    </>
  );
};

export default TestJeeDPage;
